import { CartItem } from '@api/cart/cart.models';
import { PhysicalStoreDetail } from '@api/store-locator/physical-store/models/physical-store.models';

export enum FastSintAvailability {
    FULL = 1,
    PARTIAL = 2,
}

export enum FastSintMethod {
    PICKUP = 'PICKUP',
    WISH = 'WISH',
}

export interface ExploreFsResponse {
    isFastSint: boolean;
}

export interface DetailFsResponse {
    isFastSint: boolean;
    physicalStoresList: FastSintStore[];
}

export interface FastSintStore {
    id: string;
    availability: FastSintAvailability;
    dateFastSint: string;
    dateNoFastSint: string;
    itemsFastSint: FastSintStoreItem[];
    itemsNoFastSint: FastSintStoreItem[];
    keys: FastSintTranslationKeys;
}

export interface FastSintStoreItem {
    sku: string;
    cartItem: CartItem;
}

export interface FastSintPhysicalStoreDetail extends PhysicalStoreDetail {
    fastSint: FastSintStore;
}

export interface FastSintCommonParameters {
    storeId: string;
    languageId: string;
    orderId: number;
    countryCode: string;
    longitude: string;
    latitude: string;
    radioMax?: string;
    userId: string;
}

export type FastSintTranslationKey = 'fastsint' | 'nofastsint' | 'nofastsintpickup' | 'noready' | 'noreadypickup' | 'ready' | 'remaining';

export interface FastSintTranslationMap {
    key: string; // key de CMS
    params: Record<string, string>; // parámetros a pasarle {$0: '', $1: ''}
}

export type FastSintTranslationKeys = Record<FastSintTranslationKey, FastSintTranslationMap>;

export type FastSintTranslations = Record<FastSintTranslationKey, string>;
